import React, { ReactNode } from "react";
import { Card } from "primereact/card";
import classNames from "classnames";
import styles from "./FormLayout.module.scss";

export interface FormLayoutProps {
  children: ReactNode;
  title: string | ReactNode;
  error?: string | null;
  description?: string | ReactNode | null;
  className?: string;
}

export const FormLayout: React.FC<FormLayoutProps> = ({
  children,
  title,
  error = null,
  description = null,
  className = "",
}) => {
  return (
    <Card title={title} className={classNames(styles.card, { [styles.error]: error }, className)}>
      {description && <div className={styles.description}>{description}</div>}
      <div className={styles.content}>{children}</div>
    </Card>
  );
};
